import React from 'react'
import './theme.scss'
import datepicker from '../../assets/images/event.svg'
import Icon from '@material-ui/core/Icon'
import 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import { EMPTY, getErrorText, INVALID_DATE } from '../../pages/Registration/validators'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputTooltip from '../Tooltip/InputTooltip'

function DatePickerIcon() {
    return (
        <Icon className="text-input-select-icon">
            <img src={datepicker} alt="datepicker" />
        </Icon>
    )
}

export default function DatePicker({
    formId,
    inputId,
    handleChange,
    label,
    value,
    error,
    oneOfDates,
    tooltipText,
}) {
    const calendarId = `${formId}-${inputId}-datepicker`
    const isError = !oneOfDates && error !== null && error !== undefined

    const labelElem = (
        <div className="text-input-tooltip">
            <div className="text-input-tooltip__text">{label}</div>
            {tooltipText && <InputTooltip text={tooltipText} />}
        </div>
    )
    return (
        <div className="text-input-wrapper">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        id={calendarId}
                        label={labelElem}
                        value={value}
                        onChange={handleChange}
                        autoOk={true}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        InputAdornmentProps={{
                            position: 'start',
                        }}
                        emptyLabel="DD/MM/YYYY"
                        keyboardIcon={<DatePickerIcon />}
                        error={isError}
                        InputLabelProps={{
                            style: {
                                width: '230px',
                            },
                        }}
                    />
                    {/* regular validation */}
                    {oneOfDates === undefined && isError && INVALID_DATE !== error && (
                        <FormHelperText
                            id="component-error-text"
                            error={isError}
                            className="text-input-helper"
                        >
                            {label + getErrorText(error)}
                        </FormHelperText>
                    )}
                    {/* validation in group of inputs */}
                    {oneOfDates === false && isError && EMPTY === error && (
                        <FormHelperText
                            id="component-error-text"
                            error={isError}
                            className="text-input-helper"
                        >
                            {'One of these dates is mandatory.'}
                        </FormHelperText>
                    )}
                    {/* validation in group of inputs with future/past */}
                    {oneOfDates === false && isError && EMPTY !== error && INVALID_DATE !== error && (
                        <FormHelperText
                            id="component-error-text"
                            error={isError}
                            className="text-input-helper"
                        >
                            {label + getErrorText(error)}
                        </FormHelperText>
                    )}
                </>
            </MuiPickersUtilsProvider>
        </div>
    )
}
